import { Plug, Plus, Workflow } from '@lucide/vue';
import type { CommandFactory } from './commands';
import { appLocationCommand } from './appCommand';

/**
 * Flow's app-wide palette entries (I-2348) beyond its navbar (list, new
 * automation): a new graph, the plugins and a new plugin. Starting an
 * automation joins the palette while Flow is open (frontend/flow).
 */
export const flowCommands: CommandFactory = ({ router, t, appLabel: flow }) => [
  appLocationCommand(router, {
    id: 'flow.newGraph',
    app: 'flow',
    group: flow,
    label: `${flow}: ${t('automations.nav.new_graph')}`,
    href: '/flow/new/graph',
    icon: Workflow,
    keywords: ['flow', 'graph', 'automation', 'neu', 'new'],
  }),
  appLocationCommand(router, {
    id: 'flow.plugins',
    app: 'flow',
    group: flow,
    label: `${flow}: ${t('automations.nav.plugins')}`,
    href: '/flow/plugins',
    icon: Plug,
    category: 'navigation',
    keywords: ['flow', 'plugins', 'erweiterungen'],
  }),
  appLocationCommand(router, {
    id: 'flow.newPlugin',
    app: 'flow',
    group: flow,
    label: `${flow}: ${t('automations.plugins.new')}`,
    href: '/flow/plugins/new',
    icon: Plus,
    keywords: ['flow', 'plugin', 'neu', 'new'],
  }),
];
